import { useState } from "react";
import type { MaterialUsageReportStatus } from "@/lib/service/materialUsageClient";
import { ghostBtnClass, primaryBtnClass } from "./serviceShared";

export function ServiceMaterialUsageActions(props: {
  status: MaterialUsageReportStatus | null;
  accountName: string;
  busy: boolean;
  mailStatus: string | null;
  onCertify: () => void;
  onReopen: () => void;
  onSubmit: () => void;
}) {
  const [checked, setChecked] = useState(false);
  const editable = props.status === null || props.status === "draft";

  if (props.status === "submitted") {
    return (
      <p className="text-sm text-gray-700 dark:text-zinc-300">
        Submitted. Stock is drawn and this report stays closed.
        {props.mailStatus ? ` Mail: ${props.mailStatus}.` : ""}
      </p>
    );
  }

  if (props.status === "certified") {
    return (
      <div className="flex flex-wrap gap-2">
        <button type="button" className={ghostBtnClass} disabled={props.busy} onClick={props.onReopen}>
          Reopen
        </button>
        <button type="button" className={primaryBtnClass} disabled={props.busy} onClick={props.onSubmit}>
          Submit
        </button>
      </div>
    );
  }

  if (!editable) return null;

  return (
    <div className="space-y-2">
      <label className="flex items-start gap-2 text-sm text-gray-800 dark:text-zinc-200">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={checked}
          onChange={(event) => setChecked(event.target.checked)}
        />
        <span>I certify this usage is correct and final. This stamps {props.accountName}.</span>
      </label>
      <button type="button" className={primaryBtnClass} disabled={props.busy || !checked} onClick={props.onCertify}>
        Certify
      </button>
    </div>
  );
}
